module.exports = __webpack_public_path__ + "img/client-18.af304fc8.png";